/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import { Button, Modal } from "components/haven-design";
import { Viewer } from "components/auth/types";
import { QueryInterestProfile_interest as InterestType } from "types/gql-types";
import { Action } from "pages/dashboard/interests-profile/components/reason-modal";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";
import ActionsTabs from "./actions-tabs";
import ActionsViews from "./actions-views";
import { useBatchActionsController } from "./use-batch-actions-controller";

type Props = {
  focusedAction?: Action;
  interestListID: string;
  viewer: Viewer;
  interest: InterestType;
  setBatchActionsModalFocusedAction: React.Dispatch<React.SetStateAction<Action | undefined>>;
}

const BatchActionsModal: React.FC<Props> = ({
  focusedAction,
  interestListID,
  viewer,
  interest,
  setBatchActionsModalFocusedAction,
}) => {
  const {
    activeAction,
    switches,
    tabErrors,
    tabErrorTooltips,
    errorMsgs,
    fieldErrors,
    disableSubmitControls,
    changeStatusState,
    resetAllState,
    onSwitchToggle,
    onTabClick,
    onSwitchChange,
    submitAllActions,
  } = useBatchActionsController(
    focusedAction,
    setBatchActionsModalFocusedAction,
    interestListID,
    interest,
  );

  const onRequestClose = () => {
    resetAllState();
    // eslint-disable-next-line no-undefined
    setBatchActionsModalFocusedAction(undefined);
  };

  return (
    <Modal
      title="Batch Actions for 1 Applicant:"
      isOpen={Boolean(focusedAction)}
      onRequestClose={onRequestClose}
      fullScreen
      fullWidth
      scroll="paper"
      maxWidth="md"
    >
      <DialogContent>
        <Grid container spacing={2}>
          <ActionsTabs
            action={activeAction}
            switches={switches}
            tabErrors={tabErrors}
            tabErrorTooltips={tabErrorTooltips}
            onSwitchToggle={onSwitchToggle}
            onTabClick={onTabClick} />
          <ActionsViews
            action={activeAction}
            interest={interest}
            interestListID={interestListID}
            viewer={viewer}
            errorMsgs={errorMsgs}
            fieldErrors={fieldErrors}
            changeStatusState={changeStatusState}
            onSwitchChange={onSwitchChange}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button id="batch-actions-cancel" color="secondary" size="L" onClick={onRequestClose} marginRight>
            Cancel
        </Button>
        <Button id="batch-actions-send" color="primary" size="L" onClick={submitAllActions} disabled={disableSubmitControls}>
            Send
        </Button>
      </DialogActions>
    </Modal>
  );
};
export default BatchActionsModal;
